module.exports = {
    ROUTE: {
        transactional: "Transactional",
        promotional: "Promotional",
      },
    
      PLAN_TYPE: {
        C: "Credit",
        A: "Amount",
      },
      WA_TEMPLATE_TYPE: {
        auth: "Auth",
        utility: "Utility",
        market: "Market",
        open: "Open",
      },
    allowedCountries: {
        IN: "India",
        BD: "Bangladesh",
      },
      SMTP_TYPE: {
        sarv_SMTP: "Sarv Smtp",
        whitelabel_SMTP: "whitelabel SMTP"
      },
    mainResselerId: "66487782",
 SMS: {
    GATEWAY_ROUTE:[
      { label: 'Transactional', value: 'transactional' },
      { label: 'Promotional', value: 'promotional' },
      { label: 'Explicit', value: 'explicit' },
      { label: 'Implicit', value: 'implicit' }, // spelling fixed from "lable"
    ],
    GATEWAY_TYPES: [
      { label: 'SMPP', value: 'SMPP' },
      { label: 'other', value: 'Other' },
    ],
    SMSC_TYPE: [
      { label: 'Transmitter (TX) & Receiver (RX)', value: 'TNRX' },
      // { label: 'Transceiver (TRX)', value: 'TRX' },
    ],
    AllowedCountries: [
      { label: 'India', value: '91' },
    ]
  },
    VOICE : {
      ROUTE: [
        { label: 'Transactional', value: 'transactional' },
        { label: 'Promotional', value: 'promotional' },
      ],
      CLI_TYPE: [
        { label: 'Shared', value: 1 },
        { label: 'Dedicated', value: 2 },
      ],
      GATEWAY_STATUS: [
        { label: 'Active', value: 1 },
        { label: 'Inactive', value: 0 },
        { label: 'Only Report', value: 2 },
      ]
    },
   
}